import axios from "@/axios.js";

export default {
  // eslint-disable-next-line no-unused-vars
  getUser(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/user/${payload.companyId}/all`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findUser(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/user/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createUser(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/v1/user", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateUser(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/v1/user/${payload.id}`, payload.body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteUser(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/user/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetPass(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/v1/user/reset-password/${payload.id}`, payload.body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
